import {CAPTCHA_PROVIDERS_FOR_TOGGLE} from '@shared/Captcha/providers';

import {
  ConfigSchema,
  getBoolean,
  getStringUnion,
  InferConfigType,
  OmicronConfigResponseType,
  WithTypeCheck,
} from '@utils/omicron';

export const OmicronConfigSchema = {
  WEB_SHOW_AMBASSADOR: {
    value: getBoolean(),
    description:
      'Флаг на показ блока "Стать амбассадором" на странице лендинга разработчика',
    team: 'Growth',
  },
  WEB_SHOW_SUPPORT: {
    value: getBoolean(),
    description:
      'Флаг на показ блока обращения к поддержке на странице лендинга разработчика',
    team: 'Growth',
  },
  WEB_SHOW_CHINESE_LOCATION: {
    value: getBoolean(),
    description:
      'Флаг на показ контента на китайском языке лендинга разработчика',
    team: 'Growth',
  },
  WEB_SHOW_AURORA_ON_DEV_LANDING: {
    value: getBoolean(),
    description:
      'Флаг на показ блока ОС Аврора на странице лендинга разработчика',
    team: 'Growth',
  },
  WEB_DEV_LANDING_AURORA_DEFAULT_VIEW: {
    value: getBoolean(),
    description:
      'Флаг на показ блока ОС Аврора в дефолтном виде (после промо-кампании) на странице лендинга разработчика',
    team: 'Growth',
  },
  WEB_SHOW_LOCALIZATION: {
    value: getBoolean(),
    description:
      'Флаг на показ нового вида переключателя языков на лендинге разработчика',
    team: 'Growth',
  },
  DEV_ENABLE_NEW_BLOCKS: {
    value: getBoolean(),
    description:
      'Флаг на показ новых блоков на главной (причины публиковаться, продвижение)',
    team: 'Growth',
  },
  ENABLE_KIOSK_PAGE: {
    value: getBoolean(),
    description: 'Флаг на показ страницы киоска',
    team: 'Growth',
  },
  WEB_SHOW_TOOLS_LANDING: {
    value: getBoolean(),
    description: 'Флаг на показ лендинга тулбокс',
    team: 'Phoenix',
  },
  ENABLE_BLOG_AUTHORS: {
    value: getBoolean(),
    description: 'Флаг на показ информации об авторах статей',
    team: 'Growth',
  },
  CAPTCHA_PROVIDER: {
    value: getStringUnion('yandex', CAPTCHA_PROVIDERS_FOR_TOGGLE),
    description: 'Тоггл отвечает за выбор провайдера капчи',
    team: 'Growth',
  },
  SHOW_CAPTCHA_AFTER_SUBMIT: {
    value: getBoolean(),
    description:
      'Включает показ капчи после клика по кнопке отправки формы (иначе капча показывается сразу при открытии формы)',
    team: 'Growth',
  },
  ENABLE_TIME_TO_READ: {
    value: getBoolean(),
    description: 'Флаг на показ информации времени чтения статьи',
    team: 'Growth',
  },
  ENABLE_DEV_CATEGORIES_PAGE: {
    value: getBoolean(),
    description:
      'Флаг на показ страниц категорий в блоге + редизайн главной страницы блога',
    team: 'Growth',
  },
} satisfies ConfigSchema;

export type OmicronConfigType = InferConfigType<
  WithTypeCheck<typeof OmicronConfigSchema>
>;

export type OmicronResponse = OmicronConfigResponseType<OmicronConfigType>;
